function HomeDefaultValueRequestTransformer(Util, jsonMapper, userInputRepository, quoteOptions) {

	function formatDateAndTimeTheGuidewireWay(date, time) {
		var format = "{0} at {1} AEST" ;
		var timeFormatted = '4:00PM' ;
		if ( time )
			timeFormatted = moment().tz("Australia/Sydney").format('h:mma');
		return Util.stringFormat(format, moment().tz("Australia/Sydney").format('Do MMM YYYY') , timeFormatted) ;
	}

	var staticValuesMapping = {
		quoteType:'Full',
		periodStartDate: function() { return moment().tz("Australia/Sydney").format('DD/MM/YYYY')},
		productCode : 'QPHHome',
		isInsuredsOverTheAge : false,
		isInsuredsRetired: false,
		anyConvictionsQuestion: 'no',
		hasPortableContentsClaims: 'no',
		paymentFrequency: 'everyyear',
		email : "test@test.com",
		"includeFloodCover" : true,  // testing for cordelInfo


		"policyHolders.0.mainHolder": true,
		"policyHolders.0.contact.contactType": "person",
		"policyHolders.0.contact.authorisedPersons.*.person.firstName": "An@n",
		"policyHolders.0.contact.authorisedPersons.*.person.lastName": "An@nym@us",
		"policyHolders.0.contact.authorisedPersons.*.person.dateOfBirth": "07/07/2000",
		"policyHolders.*.contact.passwordQuestionStr" : '',
		"policyHolders.*.contact.passwordQuestion" : '',
		"policyHolders.*.contact.passwordAnswer" : '',
		"policyHolders.0.contact.dateOfBirth" : '07/07/2000',
		"policyHolders.0.contact.firstName" : 'An@n',
		"policyHolders.0.contact.lastName" : 'An@nym@us',



		"dwellings.0.buildingType" : "house",
		"dwellings.0.externalWallMaterial" : "aluminium",
		"dwellings.0.homeOccupancy" : "own_live",
		"dwellings.0.coverType" : "building_and_contents",
		"dwellings.0.buildingSumInsured" : "200000",
		"dwellings.0.contentSumInsured" : "20000",
		"dwellings.0.offering" : "QPHStandardOffering",
		"dwellings.0.hasGeneralPortableContents" : false,
		"dwellings.0.portableCoverCountry" : "australia_nz",
		"dwellings.0.hasPortableContentsHomeAway" : false,


		"dwellings.0.policyOption" : {},
		"dwellings.0.policyOption.isBuildingAccidentalDamage" : true,
		"dwellings.0.policyOption.isContentsAccidentalDamage" : true,
		"dwellings.0.policyOption.isContentsDomesticWorkerComp" : false,
		"dwellings.0.policyOption.isContentsStoredAway" : false,
		"dwellings.0.policyOption.specifyCycleEquipment" : false,
		"dwellings.0.policyOption.isContentsCycleCover" : false,
		// "dwellings.0.isOwnersInsureUnits":"no",
		"dwellings.0.isSubUrbanLocated" : true,
		"dwellings.0.isRenovated" : false,
		"dwellings.0.isIncomeGenerated" : false,
		"dwellings.0.isMortgagePresent" : false,
		"dwellings.0.isUnrelatedPeople" : false,
		"dwellings.0.isUnitAboveGround" : "no",
		"dwellings.0.isPortionAboveGround" : "no",
		"dwellings.0.isCommunitySurrounded" : true,
		"dwellings.0.hasSpecifiedPortableContList" : false,
		"dwellings.0.hasIndividualContents" : false,
		"dwellings.0.homeLevels" : '1',
		"dwellings.0.isGroundLevelElevated" : "no",
		"dwellings.0.roofMaterial" : "concretetiles",
		"dwellings.0.yearsContInsurance" : "noPreviousInsurance",
		"dwellings.0.hasEntertainmentEquipment" : false,
		"dwellings.0.hasWorksArt" : false,
		"dwellings.0.homeBuiltYear" : "2000",
		"dwellings.0.isWaterTight" : true, // no data
		"dwellings.0.renovationCost" : 0,

		"dwellings.0.locationProperty" : {},
		"dwellings.0.locationProperty.knowHomeSize" : false,
		"dwellings.0.locationProperty.hasDuctedAirConditioning" : false,
		"dwellings.0.locationProperty.hasInGroundPool" : false,
		"dwellings.0.locationProperty.hasTennisCourt" : false,
		"dwellings.0.locationProperty.hasGrannyFlat" : false,
		"dwellings.0.locationSecurity" : {},
		"dwellings.0.locationSecurity.hasWindowScreenBars" : false,
		"dwellings.0.locationSecurity.isGatedCommunity" : false,
		"dwellings.0.locationSecurity.hasFixedHomeSafe" : false,
		"dwellings.0.locationSecurity.haveSecurityAlarm" : false,
		"dwellings.0.locationSecurity.hasWindowKeylocks" : false,
		"dwellings.0.locationSecurity.hasDoorSecurityScreen" : false,
		"dwellings.0.locationSecurity.hasDoorDeadlocks" : false,
		"dwellings.0.locationSecurity.has24HourConcierge" : false,
		"dwellings.0.locationSecurity.isSecurityRatedBuilding" : false,

		"dwellings.0.locationProperty.hasSheds" : false,

		"dwellings.0.isCycloneStandardlyBuilt": 'yes',
		"status" : "Draft",
		"documentDeliveryMethod": 'email',
		"displayStatus": 'Draft',
		"periodStartDateTimeAEDT": formatDateAndTimeTheGuidewireWay(moment(), moment()),
		"periodEndDateTimeAEDT" : formatDateAndTimeTheGuidewireWay(moment().add(1,'years')),
		"channel": 'portal',
	}

	function transform(intermediateRequest, userInput) {
		var staticValuesMappingNew = ApplyDefaultExcess(userInput);
		var transformedRequest = jsonMapper.setDefault(userInput, staticValuesMappingNew) ;
		console.log('transformedRequest', transformedRequest);
		return transformedRequest;
	}

	
	function ApplyDefaultExcess(userInput) {
		var staticValuesMappingNew  = staticValuesMapping;

		var excessValue = quoteOptions.getStateDefaultVoluntaryExcess(userInput.policyAddress.state);
		if(excessValue != null){
			var tempObj = {"dwellings.0.excess.voluntaryExcess": excessValue};
			staticValuesMappingNew = Object.extend(staticValuesMapping, tempObj);
		}

		var portableExcessValue = quoteOptions.getStateDefaultVoluntaryExcess(userInput.policyAddress.state, 1);
		if(portableExcessValue != null){
			var tempObj2 = {"dwellings.0.excess.portableContentVoluntaryExcess": portableExcessValue};
			staticValuesMappingNew = Object.extend(staticValuesMappingNew, tempObj2);
		}
		
		return staticValuesMappingNew;
	}

	return {
		transform: transform
	}
}
